import { VCol } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VTextField } from 'vuetify/lib/components/VTextField';

var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', [_c(VRow, [_c(VCol, [_c(VTextField, {
    attrs: {
      "type": "number",
      "step": "1",
      "min": "1",
      "color": _vm.color,
      "outlined": _vm.inpOutlined,
      "filled": _vm.inpFilled,
      "label": _vm.$t('Dashboards.components.widgetTwinTableOptionsEditor.rowsPerPageLabel')
    },
    model: {
      value: _vm.rowsPerPage,
      callback: function ($$v) {
        _vm.rowsPerPage = _vm._n($$v);
      },
      expression: "rowsPerPage"
    }
  })], 1)], 1), _c('twin-attributes-selector', {
    attrs: {
      "twins": _vm.twins,
      "twin-filter": _vm.entityFilters.twinFilter,
      "virtual-device-filter": _vm.entityFilters.virtualDeviceFilter,
      "dashboard-id": _vm.dashboardId,
      "custom-parameters": _vm.customParameters,
      "append-icon": _vm.sortIcon
    },
    on: {
      "click:append-icon": _vm.toggleSort
    },
    model: {
      value: _vm.selectedColumns,
      callback: function ($$v) {
        _vm.selectedColumns = $$v;
      },
      expression: "selectedColumns"
    }
  }), _c('nested-dashboard-options-editor', {
    attrs: {
      "custom-parameters": _vm.customParameters
    },
    model: {
      value: _vm.nestedDashboardConfig,
      callback: function ($$v) {
        _vm.nestedDashboardConfig = $$v;
      },
      expression: "nestedDashboardConfig"
    }
  })], 1);
};
var staticRenderFns = [];
export { render, staticRenderFns };